import { Link } from "react-router-dom";
import type { Article } from "@/mocks/articles";

interface ArticleCardProps {
  article: Article;
  variant?: "default" | "wide";
}

export default function ArticleCard({ article, variant = "default" }: ArticleCardProps) {
  const wide = variant === "wide";

  return (
    <article
      className={`group overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-primary-300 ${
        wide ? "flex flex-col sm:flex-row" : "flex flex-col"
      }`}
    >
      <Link
        to={`/article/${article.id}`}
        className={`relative block shrink-0 overflow-hidden bg-background-200 ${
          wide ? "h-44 w-full sm:h-auto sm:w-52 md:w-64" : "h-44 w-full md:h-48"
        }`}
        aria-label={article.title}
      >
        <img
          src={article.cover}
          alt={`${article.title} 配图`}
          title={`${article.title} - 看料88 往期存档`}
          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <span className="absolute left-3 top-3 rounded-full bg-background-50/95 px-2.5 py-1 text-[11px] font-medium text-primary-700">
          {article.category}
        </span>
      </Link>

      <div className={`flex flex-1 flex-col p-4 md:p-5 ${wide ? "justify-center" : ""}`}>
        <div className="flex items-center gap-3 text-[11px] text-foreground-500">
          <span className="flex items-center gap-1">
            <i className="ri-calendar-line" />
            {article.dateLabel}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-time-line" />
            {article.readingTime} 分钟
          </span>
          <span className="flex items-center gap-1 text-primary-600">
            <i className="ri-fire-line" />
            {article.heat}
          </span>
        </div>

        <h3 className="mt-2.5 font-heading text-base font-bold leading-snug text-foreground-950 md:text-lg">
          <Link to={`/article/${article.id}`} className="transition-colors hover:text-primary-600">
            {article.title}
          </Link>
        </h3>

        <p className={`mt-2 text-sm leading-relaxed text-foreground-600 ${wide ? "line-clamp-3" : "line-clamp-2"}`}>
          {article.summary}
        </p>

        <div className="mt-3 flex flex-wrap items-center gap-2">
          {article.tags.slice(0, 3).map((tag) => (
            <span
              key={tag}
              className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] text-secondary-800"
            >
              {tag}
            </span>
          ))}
        </div>
      </div>
    </article>
  );
}